<div class="container h-100 canvas-page">
    <div *ngIf="isGivingLoading == true" class="row h-100 justify-content-center align-items-center">
        <div class="text-center">
            <app-loading-spinner></app-loading-spinner>
        </div>
    </div>
    <div class="row justify-content-center align-items-center VerticalMargin mb-5"
        [ngClass]="isGivingLoading == false ? 'visible' : 'hidden'">
        <div class="card RegularForm rounded col-12 col-lg-9 canvas-panel" 
            [class.SmallArabicFont]="globalService.isRTL == true">
            <div class="card-body MyCardBody rounded-bottom" *ngIf="result != null">
                <div class="row">
                    <div class="col-5">
                        <label for="year">{{ globalService.Get("YEAR") }}</label>
                        <select #yearSelect id="year" class="form-control"
                            [class.classicRTL]="globalService.isRTL == true"
                            [class.classic]="globalService.isRTL == false" name="year"
                            (change)="isYearChanged(yearSelect.value)" [(ngModel)]="selectedYear">
                            <option [value]="0" *ngIf="result.years.length > 1">
                                {{ globalService.Get("ALL") }}
                            </option>
                            <option *ngFor="let year of result.years" [value]="year">
                                {{ year }}
                            </option>
                        </select>
                    </div>
                    <div class="col-7">
                        <label for="type">{{ globalService.Get("TYPE") }}</label>
                        <select #typeSelect id="type" class="form-control"
                            [class.classicRTL]="globalService.isRTL == true"
                            [class.classic]="globalService.isRTL == false" name="type"
                            (change)="isTypeChanged(typeSelect.value)" [(ngModel)]="selectedType">
                            <option [value]="0">
                                {{ globalService.Get("ALL") }}
                            </option>
                            <option [value]="1">
                                {{ globalService.Get("DEDUCTIBLE") }}
                            </option>
                            <option [value]="2">
                                {{ globalService.Get("NONDEDUCTIBLE") }}
                            </option>
                        </select>
                    </div>
                </div>
                <br>
                <app-member-header *ngIf="memberId!=0" [MemberId]="memberId"
                    (completedDisplay)="CompletedMemberHeader()">
                </app-member-header>
                <br>
                <h2 [class.ArabicFont]="globalService.isRTL == true" class="formSectionHeader">
                    {{ globalService.Get("PAYMENT_HISTORY") }}
                </h2>

                <br>
                <table class="table table-striped entity-list-table">
                    <thead>
                        <tr>
                            <td scope="col" ><small>#</small></td>
                            <td scope="col"><small>Date</small></td>
                            <td scope="col"><small>Amount</small></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let donation of data; let idx = index">
                            <td scope="row"><small>{{ idx + 1 }}</small></td>
                            <td><small>{{ donation.donationDate | date: 'MM/dd/yyyy' }}</small></td>
                            <td><small>${{ donation.donationAmount | number }}</small></td>
                        </tr>
                    </tbody>
                </table>
                <br>
                <div class="row">
                    <div class="col-12 mt-3 text-center">
                        <button [class.pt-2]="globalService.isRTL == true" [disabled]="selectedYear == 0"
                            class="btn optionButton btn-secondary btn-primary btn-block" [class.mr-2]="globalService.isRTL == false"
                            [class.ml-2]="globalService.isRTL == true" type="button" (click)="previewStatement()">
                            Preview Statement
                        </button>
                    </div>
                </div>    
            </div>  
        </div>
    </div>
</div>